import { Component, Input } from '@angular/core';
import { AufnahmePunktDocument, Baumart, BodenvegetationZeile, hatHumusForm, hatVegetationsformengruppe, humusformLabel, schichtLabel } from '../../../data-model';

@Component({
    standalone: false,
    selector: 'bp-bohrpunkt-vegetation',
    templateUrl: './bohrpunkt-vegetation.component.html',
    styleUrls: ['../hl-table.component.css', './bohrpunkt-vegetation.component.css'],
    
})
export class BohrpunktVegetationComponent  {
	humusformLabel = humusformLabel;
	hatHumusForm = hatHumusForm;
	hatVegetationsformengruppe = hatVegetationsformengruppe;
	schichtLabel = schichtLabel;

  @Input() bp!: AufnahmePunktDocument;
  @Input() printView!: boolean;

  constructor() { }
	
	schichten(): ('b1'|'b2'|'str'|'kr1'|'kr2'|'m')[] {
		const schichten = new Set<'b1'|'b2'|'str'|'kr1'|'kr2'|'m'>();
		this.bp.bodenvegetation.aufnahme.vegetationen.forEach((bv: BodenvegetationZeile) => {
			if (bv.schicht) schichten.add(bv.schicht);
		});
		return Array.from(schichten).sort();
	}

	private schichtOrder: Record<string, number> = {
		'b1': 1, 'b2': 2, 'str': 3, 'kr1': 4, 'kr2': 5, 'm': 6
	};

	sortedVegetationen(): BodenvegetationZeile[] {
		return [...this.bp.bodenvegetation.aufnahme.vegetationen].sort((a, b) => {
			// Zuerst nach Schicht sortieren
			const schichtA = this.schichtOrder[a.schicht || ''] || 99;
			const schichtB = this.schichtOrder[b.schicht || ''] || 99;
			if (schichtA !== schichtB) {
				return schichtA - schichtB;
			}
			// Dann nach Häufigkeit (%) absteigend sortieren
			const haeufA = parseFloat(a.haeufigkeit) || 0;
			const haeufB = parseFloat(b.haeufigkeit) || 0;
			return haeufB - haeufA;
		});
	}

	baumarten(): string {
		if (typeof this.bp.extendedHeader.baumarten === 'string') return this.bp.extendedHeader.baumarten;

		const baumarten = this.bp.extendedHeader.baumarten as Baumart[];
		let bas = '';
		for (const ba of baumarten) bas += ba.art + '';

		return bas;
	}
}
